/* meinVitalium – subtle motion layer.
   Reveal on scroll, one-time count-up in the facts band, donut and timeline draw.
   Everything stays visible without JS and is skipped for "prefers-reduced-motion". */
(function () {
  if (window.mvMotionReady) return;
  window.mvMotionReady = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  var REVEAL = [
    '.mv-section-heading',
    '.mv-feature-card',
    '.mv-claims__group',
    '.mv-intake__dose',
    '.mv-intake__step',
    '.mv-quality-card',
    '.mv-knowledge__note',
    '.mv-editorial-split',
    '.mv-recipe',
    '.mv-image-break',
    '.mv-nutrient',
    '.mv-comp__chart',
    '.mv-comp__item',
    '.mv-cta-band__inner'
  ].join(',');

  var DRAW = '.mv-comp, .mv-intake__steps';

  /* Split "300 mg" into number + unit so the unit can be styled smaller. */
  function prepareFacts(root) {
    root.querySelectorAll('.mv-facts-bar__value:not([data-mv-num])').forEach(function (el) {
      var text = el.textContent.trim();
      var m = text.match(/^(\d{1,3}(?:\.\d{3})*|\d+)(?:,(\d+))?(.*)$/);
      if (!m) { el.setAttribute('data-mv-num', ''); return; }
      var intPart = m[1];
      var dec = m[2] || '';
      var unit = m[3] || '';
      el.setAttribute('data-mv-num', intPart.replace(/\./g, '') + (dec ? '.' + dec : ''));
      el.setAttribute('data-mv-dec', String(dec.length));
      el.innerHTML = '<span class="visually-hidden">' + text.replace(/</g, '&lt;') + '</span>' +
        '<span class="mv-num" aria-hidden="true"></span>' +
        (unit.trim() ? '<span class="mv-unit" aria-hidden="true">' + unit.trim().replace(/</g, '&lt;') + '</span>' : '');
      el.querySelector('.mv-num').textContent = intPart + (dec ? ',' + dec : '');
    });
  }

  function format(n, dec) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-mv-num'));
    var dec = parseInt(el.getAttribute('data-mv-dec') || '0', 10);
    var out = el.querySelector('.mv-num');
    if (!out || isNaN(target) || target === 0) return;
    var start = null;
    var dur = Math.min(1400, 700 + target * 2);
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      out.textContent = format(target * eased, dec);
      if (p < 1) requestAnimationFrame(step);
      else out.textContent = format(target, dec);
    }
    out.textContent = format(0, dec);
    requestAnimationFrame(step);
  }

  function belowFold(el) {
    var r = el.getBoundingClientRect();
    return r.top > window.innerHeight * 0.92;
  }

  function init() {
    prepareFacts(document);
    if (reduce || !hasIO) return;

    document.documentElement.classList.add('mv-motion');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('is-in');
        if (el.classList.contains('mv-facts-bar')) {
          el.querySelectorAll('.mv-facts-bar__value[data-mv-num]').forEach(countUp);
        }
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    /* Reveal only what starts below the fold, so nothing visible flickers. */
    document.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.closest('.mv-facts-bar-section')) return;
      if (!belowFold(el)) return;
      var siblings = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(REVEAL); }) : [];
      var idx = Math.max(0, siblings.indexOf(el));
      el.style.setProperty('--mv-delay', Math.min(idx, 5) * 70 + 'ms');
      el.classList.add('mv-reveal');
      io.observe(el);
    });

    document.querySelectorAll(DRAW).forEach(function (el) {
      if (!belowFold(el)) { el.classList.add('is-in'); return; }
      io.observe(el);
    });

    document.querySelectorAll('.mv-facts-bar').forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run for re-rendered sections. */
  document.addEventListener('shopify:section:load', function (e) {
    prepareFacts(e.target);
    e.target.querySelectorAll('.mv-reveal, .mv-comp, .mv-intake__steps').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
